import * as React from 'react';
import * as revs from "./style.module.scss";
export const Revs = () => {
  const reviews = [
    {
      id: 1,
      author: 'Андрей Лондарев',
      text: 'Спасибо за демонстрационный материал. Сегодня ребёнок ещё раз убедился, что стоит продолжать заниматься. Сверстники уже завидуют - ещё дополнительная мотивация. Скоро подойдем к составлению договора. Ребёнок активно отрабатывает навык «постановки нового навыка». Запомнил ряд элементов таблицы Менделеева. Сказал: тю! Требует ещё... Деньги потрачены не зря. Всем советую присоединяться!',
      classname: `${revs.orange}`
    },
    {
      id: 2,
      author: 'София Белова',
      text: 'Спасибо за обучение! Очень мощно, ёмко, образно, структурировано! Очень довольна, этим обучением, оно оправдывает вложенные средства на 1000%. Понравилась поддержка в чате и на вебинарах- все вопросы разбирались до полного понимания. Все материалы остались в доступе. Теперь дело за малым- продолжать самостоятельно внедрять новое умение в свою жизнь и приобщать к нему детей. Спасибо всей команде!',
      classname: `${revs.purple}`
    },
    {
      id: 3,
      author: 'Анастасия Федосеева',
      text: 'Вы вдохновляете, а материал подаете интересно, с юмором. Теперь я знаю, как эффективно готовиться к экзаменам, а мне, как ученице 11 класса, эти навыки очень кстати:) Как хорошо, что я учусь по новым технологиям еще в школе;) В итоге передо мной открываются огромные перспективы: легкое и эффективное обучение, свободное владение ин.языками - столько, сколько захочу:) , подготовка к экзамену за меньшие сроки и с лучшими результатами. P.S. Это мое ЛУЧШЕЕ ВЛОЖЕНИЕ ДЕНЕГ!:)',
      classname: `${revs.green}`
    }
  ];
  const [isReadMore, setIsReadMore] = React.useState(-1);
  const btnClickShow = (index) => {
    setIsReadMore(index)
  };
  const btnClickHide = () => {
    setIsReadMore(-1)
  }
  return (
    <section className={revs.revs}>
      <div className="container">
        <h2>Отзывы о курсах Advance для детей:</h2>
        <ul>
          {
            reviews.map((elem, index) => (
              <li className={elem.classname} key={index}>
                <h3>{elem.author}</h3>
                <p>{isReadMore === index ? elem.text : `${elem.text.slice(0, 150)}...`}</p>
                <button onMouseDown={()=>{btnClickShow(index)}} onMouseUp={btnClickHide}>
                  {isReadMore === index ? 'Свернуть' : 'Читать далее'}
                </button>
              </li>
            ))
          }
        </ul>
      </div>
    </section>
  );
};
